import { render } from "./ChatMessageBalloon.vue?vue&type=template&id=52931c46&scoped=true"
import script from "./ChatMessageBalloon.vue?vue&type=script&lang=js"
export * from "./ChatMessageBalloon.vue?vue&type=script&lang=js"

import "./ChatMessageBalloon.vue?vue&type=style&index=0&id=52931c46&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52931c46"]])

export default __exports__
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChatMessage});
